import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles(() => ({
  root: {
    width: '100% !important',
    maxWidth: contentMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
  },
}))

export { useStyles }
